import React from "react";
import { Avatar, Box, Divider, Stack, Typography, Chip } from "@mui/material";
import ScrapingStatusBadge from "app/pages/components/ScrapingStatusBadge";

export const ProcessBrandDetails = ({ 
  processNumber, 
  brandName, 
  nature, 
  presentation,
  is_scraping_completo,
  fonte_scraping,
  data_ultimo_scraping
}) => {
  return (
    <Stack width={"100%"} direction={"row"} gap={2} alignItems={"center"}>
      <Box width={"20%"}>
        <Avatar
          alt={brandName}
          src={`${process.env.REACT_APP_BACKEND_URL}/public/images/marcas/${processNumber}.jpg`}
          sx={{ width: 120, height: 120 }}
        >
          {String(brandName)?.charAt(0)?.toUpperCase()}
        </Avatar>
      </Box>
      <Box width={"20%"}>
        <Typography fontWeight={600}>Marca:</Typography>
        <Typography>{brandName ?? "N/I"}</Typography>
      </Box>
      <Box width={"20%"}>
        <Typography fontWeight={600}>Natureza:</Typography>
        <Typography>{nature ?? "N/I"}</Typography>
      </Box>
      <Box width={"20%"}>
        <Typography fontWeight={600}>Apresentação:</Typography>
        <Typography>{presentation ?? "N/I"}</Typography>
      </Box>
      <Box width={"20%"}>
        <Typography fontWeight={600} mb={0.5}>Status dos Dados:</Typography>
        <ScrapingStatusBadge
          is_scraping_completo={is_scraping_completo}
          fonte_scraping={fonte_scraping}
          data_ultimo_scraping={data_ultimo_scraping}
          size="small"
          showTooltip={true}
        />
      </Box>
      <Divider />
    </Stack>
  );
};
